import AdminBulkCategoryTools from "@/components/AdminBulkCategoryTools";
import AdminCsvImportCard from "@/components/AdminCsvImportCard";
// Image Health + State Backfill still run automatically via cron jobs —
// their admin cards were removed from this tab to reduce clutter. They
// can be re-added if you ever want manual triggers back.
import AdminCategoryManager from "@/components/AdminCategoryManager";
import AdminSubscriptionFailuresCard from "@/components/AdminSubscriptionFailuresCard";
import AdminSettingsCard from "@/components/AdminSettingsCard";
import AdminSupportTicketsCard from "@/components/AdminSupportTicketsCard";
import AdminGoogleReviewsCard from "@/components/AdminGoogleReviewsCard";

export default function AdminBusinessesTab() {
  return (
    <div className="space-y-6">
      <AdminSettingsCard />
      <AdminSupportTicketsCard />
      <AdminGoogleReviewsCard />
      <AdminSubscriptionFailuresCard />
      <AdminCategoryManager />
      <AdminBulkCategoryTools />
      <AdminCsvImportCard />
    </div>
  );
}
